// extracted by mini-css-extract-plugin
export default {"layout":"RoomLayout_layout__SKe1o","leftTab":"RoomLayout_leftTab__nqzha","rightTab":"RoomLayout_rightTab__+61js"};